export default __webpack_public_path__ + "static/media/IMG-20210203-WA0000.31ae330b.jpg";